import React, { useEffect, useState } from "react";
import { object, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Button from "../../atoms/Button";
import ContributorImage from "../../atoms/ContributorImage";
import ProfileHeadline from "../../atoms/ProfileHeadline";

import { verifyEmail, getUser } from "../../helper/api";
import { setLoading } from "../../helper/actions";
import { staticTexts } from "../../utils/Translate";

import "./my-profile.m.css";

const MyProfile = ({ member, navigateToPage, setLoading, publisherAttributes }) => {
  const [currentMember, setCurrentMember] = useState(member);

  const editProfileClick = () => navigateToPage("/profile/edit");

  const changePasswordClick = () => {
    setLoading(true);

    // User needs to validate the email account so send out an email to verify
    verifyEmail(currentMember.email)
      .then(navigateToPage("/profile/change-password"))
      .finally(setLoading(false));
  };

  useEffect(() => {
    getUser().then(res => {
      setCurrentMember(res.member);
    });
  }, []);

  const address = get(currentMember, ["metadata", "address"], "-");
  const dob = get(currentMember, ["metadata", "dob"], "-");
  const contactNumber = get(currentMember, ["metadata", "contact-number"], "-");

  return (
    <div styleName="container">
      <ProfileHeadline title={staticTexts(publisherAttributes.lang).myProfile} />

      <div styleName="wrapper">
        <ContributorImage authorObj={currentMember} />
        <div styleName="profile-details">
          <span styleName="profile-name">{currentMember.name}</span>

          <div styleName="profile-columns">
            <div styleName="label-value">
              <span styleName="label">{staticTexts(publisherAttributes.lang).email} : </span>
              <span styleName="value">{currentMember.email}</span>
            </div>
            <div styleName="label-value">
              <span styleName="label">{staticTexts(publisherAttributes.lang).country} : </span>
              <span styleName="value">{address}</span>
            </div>
          </div>

          <div styleName="profile-columns">
            <div styleName="label-value">
              <span styleName="label">{staticTexts(publisherAttributes.lang).birthday} : </span>
              <span styleName="value">{dob}</span>
            </div>
            <div styleName="label-value">
              <span styleName="label">{staticTexts(publisherAttributes.lang).contact} : </span>
              <span styleName="value">{contactNumber}</span>
            </div>
          </div>

          <div styleName="actions">
            <Button
              content={staticTexts(publisherAttributes.lang).editProfileBtnText}
              buttonType="type4"
              onClick={editProfileClick}
            />
            {currentMember && !currentMember["verification-status"].includes("social-") && (
              <div styleName="change-pwd" onClick={changePasswordClick}>
                {staticTexts(publisherAttributes.lang).changePassword}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

MyProfile.propTypes = {
  member: object.isRequired,
  navigateToPage: func.isRequired,
  setLoading: func,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    member: state.member || null,
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

const mapDispatchToProps = dispatch => ({
  navigateToPage: url => global.app.navigateToPage(dispatch, url),
  setLoading: isLoading => dispatch(setLoading(isLoading))
});

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);
